
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(badge, badgeIndex) {
                    return _createElement('span', {
                        'className': 'label_ui cm_badge cm_badge__' + this.toKebabCase(badge),
                        'key': badge
                    }, '\n          ', badge, '\n        ');
                }
                function repeatI2(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                function scopeProduct3() {
                    var product = this.productData ?? this;
                    return [product.is_autosync_allowed ? _createElement('button', {
                            'className': 'cm_view-on-vehicle-btn btn btn-2',
                            'onClick': () => window.Convermax.openAutoSyncDialog(product.autosync_id, product.autosync_mpn, product.FitmentType?.includes('Tire')),
                            'type': 'button',
                            'key': '44251'
                        }, '\n    ', _translate(`view_product_on_vehicle`), '\n  ') : null];
                }
                return _createElement('div', { 'className': 'product-card' + (this.is_promotional_item ? ' cm_promotion' : '') }, _createElement('div', { 'className': 'hover-2' }, _createElement('div', { 'className': 'product-card_header' }, _createElement('figure', { 'className': 'product-card_image' }, _createElement('a', { 'href': this.url }, _createElement('img', {
                    'className': 'featured-image front img-lazy blur-up lazyautosizes lazyloaded',
                    'alt': this.removeHTML(this.title),
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'onError': this.onImageError
                }))), _createElement.apply(this, [
                    'div',
                    { 'className': 'product-card_label label_ui-group' },
                    this.on_sale ? _createElement('span', {
                        'className': 'label_ui label_ui-sale',
                        'key': '533'
                    }, 'Sale') : null,
                    this._badges ? _map(this._badges, repeatBadge1.bind(this)) : null
                ])), _createElement('div', { 'className': 'product-card_body' }, _createElement('div', { 'className': 'product-card_row' }, _createElement('small', { 'className': 'product-card_vendor' }, this.vendor && this.vendor_url ? _createElement('a', Object.assign({}, {
                    'href': this.vendor_url,
                    'title': this.vendor,
                    'key': '934'
                }, { dangerouslySetInnerHTML: { __html: typeof this.vendor === 'undefined' ? '' : this.vendor } })) : null), _createElement('h3', { 'className': 'product-card_name' }, _createElement('a', Object.assign({}, {
                    'href': this.url,
                    'aria-label': 'title'
                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })))), _createElement('div', { 'className': 'product-card_footer' }, this.on_sale ? _createElement('div', {
                    'className': 'product-price',
                    'key': '1468'
                }, _createElement('span', { 'className': 'price-sale' }, this.formatPrice(this.price)), _createElement('span', { 'className': 'price-compare' }, this.formatPrice(this.compare_at_price)), this.set_qty && !this.price_varies ? _createElement('div', {
                    'className': 'price-item--set',
                    'key': '1687'
                }, '\n            ', _translate(`product_set_of`, {  count: this.set_qty  }), ': ', this.formatPrice(this.price * this.set_qty), '\n          ') : null) : null, !this.on_sale ? _createElement('div', {
                    'className': 'product-price',
                    'key': '1924'
                }, this.price_varies ? _createElement('span', { 'key': '1984' }, _translate(`price_from`), ' ') : null, _createElement('span', { 'className': 'price' }, this.formatPrice(this.min_price || this.price)), this.set_qty && this.price_varies ? _createElement('div', {
                    'className': 'price-item--set',
                    'key': '2148'
                }, '\n            ', _translate(`product_set_of`, {  count: this.set_qty  }), ': ', this.formatPrice(this.price * this.set_qty), '\n          ') : null) : null, [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '23840'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI2.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null], _createElement('div', { 'className': 'product-card_action' }, this.out_of_stock ? _createElement('span', { 'key': '2833' }, _createElement('svg', {
                    'xmlns': 'http://www.w3.org/2000/svg',
                    'x': '0px',
                    'y': '0px',
                    'width': '24',
                    'height': '24',
                    'viewBox': '0 0 24 24'
                }, _createElement('path', {
                    'd': 'M11 0.7H13V23.3H11z',
                    'transform': 'rotate(-45.001 12 12)'
                }), _createElement('path', {
                    'd': 'M0.7 11H23.3V13H0.7z',
                    'transform': 'rotate(-45.001 12 12)'
                }))) : null, this.variant_ids.length > 1 && !this.out_of_stock || this.ProductScope === 'master' ? _createElement('a', {
                    'href': this.url,
                    'title': 'Select options',
                    'key': '3186'
                }, _createElement('svg', {
                    'className': 'svg-setting',
                    'width': '25',
                    'height': '25',
                    'viewBox': '0 0 512.002 512.002'
                }, _createElement('use', { 'xlinkHref': '#svg-setting' }))) : null, this.variant_ids.length <= 1 && !this.out_of_stock && (!this.ProductScope || this.ProductScope === 'child') ? _createElement('form', {
                    'method': 'post',
                    'action': '/cart/add',
                    'encType': 'multipart/form-data',
                    'key': '3525'
                }, _createElement('input', {
                    'type': 'hidden',
                    'name': 'id',
                    'value': this.variant_ids
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'quantity',
                    'value': this.set_qty || 1
                }), this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                    'type': 'hidden',
                    'name': 'properties[Fitment]',
                    'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                    'key': '3903'
                }) : null, _createElement('button', {
                    'className': 'btn btn-add-to-cart',
                    'data-quick-buy': true,
                    'data-variant-id': this.variant_ids
                }, _createElement('svg', {
                    'className': 'svg-cart',
                    'width': '25',
                    'height': '25',
                    'viewBox': '0 0 512.002 512.002'
                }, _createElement('use', { 'xlinkHref': '#svg-cart' })))) : null, [scopeProduct3.apply(this, [])])), this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '4857'
                }) : null)));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []